import React, { useState, useEffect } from 'react';
import { Text, Button, BackButton, Input, Loading } from 'ui';
import { updateCampaign, useCampaign, useAuth, isCampaignURLAvailable } from 'api';
import { useParams, useHistory } from 'react-router-dom';

export default function CampaignSlug(props) {
  
  const { campaignId } = useParams();
  const auth = useAuth();
  const history = useHistory();
  const campaign = useCampaign(auth ? auth.user.companyId : null, campaignId);
  
  const [slug, setSlug] = useState("");
  useEffect(() => {
    if(campaign) {
      setSlug(campaign.slug || "");
    }
  }, [campaign]);
  
  
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  async function save() {
    if(!slug) {
      setError("Please choose a url.");
      return;
    }
    setChecking(true);
    
    // todo: check for invalid characters
    
    const available = await isCampaignURLAvailable(slug);
    if(!available) {
      setChecking(false);
      setError("That URL is not available. Please try another.");
      return;
    }
    
    await updateCampaign(auth.user.companyId, campaignId, {slug});
    
    history.push('view');
  }
  
  if(!campaign) {
    return <Loading/>;
  }
  
  return (
    <div>
      <div style={{display:'flex', flexDirection:'row', alignItems:'center', backgroundColor:'white', padding:"24px"}}>
        <BackButton onClick={() => props.history.goBack()} style={{marginRight:16}}/>
        <Text large light style={{flex:1}}>Build a Campaign</Text>
      </div>
      <div style={{padding:"0 24px 40px 24px"}}>
        <div style={{height:80, paddingBottom:40, display:'flex', flexDirection:'row', alignItems:'center'}}>
          <Text huge color="#00b2a8" style={{flex:1}}>{campaign.name}</Text>
        </div>
        
        <div style={{maxWidth:600, margin:'0 auto'}}>
          <Text large light block style={{marginBottom:16}}>Choose a URL</Text>
          
          <div style={{display:'flex', flexDirection:'row', marginBottom:24}}>
            <Text block style={{padding:"16px 8px 0 0"}}>https://tap.page#</Text>
            <Input
              large
              value={campaign.slug} 
              onChange={setSlug}
              style={{flex:1, margin:'0 16px 0 0'}}
            />
          </div>
          
          {error && <Text color="red" block small style={{paddingBottom:16}}>{error}</Text>}
          
          <div>
            <Button onClick={save} label={checking ? "Checking..." : "NEXT"} small white backgroundColor="#243746"/>
            <Button onClick={() => props.history.goBack()} label="Cancel" small/>
          </div>
        </div>
      </div>
    </div>
  );
}